import React from 'react'

const CommissionIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="commissionIcon">
      <path
        d="M3.5 22.1668V5.8335H24.5V22.1668H3.5ZM4.66667 21.0002H23.3333V7.00016H4.66667V21.0002ZM9.91667 19.2502H11.0833V18.0835H12.5183C12.7734 18.0835 12.9869 17.9976 13.1588 17.8257C13.3307 17.6538 13.4167 17.4407 13.4167 17.1863V14.314C13.4167 14.0597 13.3307 13.8466 13.1588 13.6747C12.9869 13.5028 12.7738 13.4168 12.5195 13.4168H8.75V11.0835H13.4167V9.91683H11.0833V8.75016H9.91667V9.91683H8.48167C8.22656 9.91683 8.01306 10.0028 7.84117 10.1747C7.66928 10.3466 7.58333 10.5601 7.58333 10.8152V13.6875C7.58333 13.9418 7.66928 14.1549 7.84117 14.3268C8.01306 14.4987 8.22617 14.5847 8.4805 14.5847H12.25V16.918H7.58333V18.0847H9.91667V19.2502ZM18.6667 18.6435L20.4622 16.8492H16.87L18.6667 18.6435ZM16.8723 11.4428H20.4622L18.6667 9.64733L16.8723 11.4428Z"
        fill="#EF8658"
      />
    </g>
  </svg>
)

export default CommissionIcon
